import {LogService as LogServiceType} from 'services/log/types';
import {deviceService} from 'services/device';
// import {logService} from 'services/log';
import {createProxy} from 'interactors/errorHandler';

// TODO: turn on again later.
const logService: LogServiceType = {
  log() {},
  info() {},
};

interface Dependencies {
  service?: DeviceService;
  logger?: LogServiceType;
}

export function create({
  service = deviceService,
  logger = logService,
}: Dependencies = {}): DeviceService {
  const methods = ['sendMessage', 'updateWidget'];
  const handler = logger.log;
  return createProxy({service, methods, handler});
}
